const GREETING = {
	en: "Hi, I'm coming from your website",
	ar: "مرحباً، أتواصل معكم من موقعكم",
} as const;

/**
 * The link before the visitor has said anything (PLT-2164). There is no
 * conversation to carry yet, so it carries no code.
 */
export function plainWhatsAppLink(number: string, language: string): string {
	const text = language === "ar" ? GREETING.ar : GREETING.en;
	return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
